export default __webpack_public_path__ + "static/media/img2.f7f9e986.PNG";